import { Token } from '@uniswap/sdk-core'
import { NetworkInfo, KavaNetworkInfo } from 'constants/networks'
import { WKAVA_ADDRESS } from '../constants'

export interface SerializedToken {
  chainId: number
  address: string
  decimals: number
  symbol?: string
  name?: string
}

export function serializeToken(token: Token): SerializedToken {
  return {
    chainId: token.chainId,
    address: token.address,
    decimals: token.decimals,
    symbol: token.symbol,
    name: token.name,
  }
}

export function formatTokenSymbol(address: string, symbol: string, activeNetwork?: NetworkInfo) {
  // dumb catch for matic
  if (address === WKAVA_ADDRESS && activeNetwork === KavaNetworkInfo) {
    return 'KAVA'
  }

  return symbol
}

export function formatTokenName(address: string, name: string, activeNetwork?: NetworkInfo) {
  // dumb catch for matic
  if (address === WKAVA_ADDRESS && activeNetwork === KavaNetworkInfo) {
    return 'KAVA'
  }

  return name
}
